export default __webpack_public_path__ + "static/media/promomodalnflbg.75f3a685.png";